import _extends from "@babel/runtime/helpers/extends";
import { Box } from '@wix/design-system';
import React from 'react';
import { EllipsisContext } from './EllipsisContext';
import { EllipsisText } from './EllipsisText';
import { EllipsisTooltipWrapper } from './EllipsisTooltipWrapper';
export const Ellipsis = _ref => {
  let {
    maxTextLength,
    dataHook,
    text: fullText,
    position = 'top',
    ...textProps
  } = _ref;
  const [displayTruncatedText, setDisplayTruncatedText] = React.useState(fullText);
  const hasEllipsis = displayTruncatedText !== fullText;
  return /*#__PURE__*/React.createElement(EllipsisContext.Provider, {
    value: {
      displayTruncatedText,
      setDisplayTruncatedText
    }
  }, /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHook,
    display: "contents"
  }, /*#__PURE__*/React.createElement(EllipsisTooltipWrapper, {
    fullText: fullText,
    hasEllipsis: hasEllipsis,
    position: position
  }, /*#__PURE__*/React.createElement(EllipsisText, _extends({
    text: fullText
  }, textProps)))));
};

/**
 * Wrapper for use as a Trans component: receives translation content as children
 * and renders Ellipsis with tooltip when text is truncated.
 */
export const EllipsisForTrans = _ref2 => {
  let {
    children,
    maxWidth = 160,
    ...rest
  } = _ref2;
  const text = typeof children === 'string' ? children : Array.isArray(children) ? children.join('') : String(children ?? '');
  return /*#__PURE__*/React.createElement(Ellipsis, _extends({
    text: text,
    maxWidth: maxWidth,
    componentProps: {
      size: 'small',
      weight: 'bold'
    }
  }, rest));
};
//# sourceMappingURL=Ellipsis.js.map